import { trigger, state, style, animate, transition } from '@angular/animations';

export const slide = trigger('slide', [
  state('down', style({ transform: 'translateY(0)' })),
  transition(':enter', [
    style({ transform: 'translateY(-15%)' }),
    animate('0.2s ease-out')
  ]),
  transition(':leave', [
    animate('0.2s ease-out', style({ transform: 'translateY(-15%)' }))
  ])
]);



// WEBPACK FOOTER //
// ./src/app/animations.ts